import React, { useEffect, useMemo } from 'react'

import { ButtonClean, CurrencyInput, Fieldset, PriceString, Tooltip } from '@fourthwall/components'
import { routing } from '@utils/routing'

import { isPaidTier } from '../../../../utils'
import { useTierContext } from '../../hooks/useTierContext'
import { FormFields } from '../../providers/TierProvider/types'

export const Price = () => {
  const { tier, isCreatingNewTier, form, annualDiscount } = useTierContext()

  const membersCount = tier?.statistics.membersCount

  // Disable discount and automatical international pricing conversion when price is 0 (free tier)
  useEffect(() => {
    if (form.dirty && parseFloat(form.values.price) === 0) {
      form.setFieldValue(FormFields.discount, false)
      form.setFieldValue(FormFields.convertInternationalPricing, true)
    }
  }, [form.values.price])

  const renderSuggestion = () => {
    if (form.values.price && parseFloat(form.values.price) === 0) {
      return 'All free accounts will be automatically assigned to this free tier.'
    }

    if (!annualDiscount) {
      return (
        <ButtonClean
          withUnderline
          appearance="secondary"
          type="button"
          label="Offer annual memberships"
          to={routing.memberships.settings.general}
        />
      )
    }

    if (!form.values.price) return undefined

    const yearPrice = form.values.price
      ? parseFloat(form.values.price) * 12 -
        parseFloat(form.values.price) * 12 * (annualDiscount / 100)
      : 0

    return (
      <>
        <PriceString value={yearPrice} /> price per year (
        <ButtonClean
          withUnderline
          appearance="secondary"
          type="button"
          label={`${annualDiscount}% discount`}
          to={routing.memberships.settings.general}
        />
        )
      </>
    )
  }

  const disabled = useMemo(() => {
    if (isCreatingNewTier) return false

    if (membersCount) return membersCount > 0

    if (tier) return !isPaidTier(tier)
  }, [tier, membersCount, isCreatingNewTier])

  if (tier && isPaidTier(tier) && membersCount && membersCount > 0) {
    return (
      <Fieldset.Row>
        <Fieldset.Item>
          <Tooltip
            placement="top"
            reference={
              <CurrencyInput
                label="Price per month"
                suggestion={renderSuggestion()}
                disabled
                {...form.getFieldProps(FormFields.price)}
              />
            }
          >
            Tier price in this currency cannot be changed when there are active members.
          </Tooltip>
        </Fieldset.Item>
      </Fieldset.Row>
    )
  }

  return (
    <Fieldset.Row>
      <Fieldset.Item>
        <CurrencyInput
          label="Price per month"
          suggestion={renderSuggestion()}
          disabled={disabled}
          {...form.getFieldProps(FormFields.price)}
        />
      </Fieldset.Item>
    </Fieldset.Row>
  )
}
